import { render, staticRenderFns } from "./OpenLocker.vue?vue&type=template&id=86b8e95c&"
import script from "./OpenLocker.vue?vue&type=script&lang=ts&"
export * from "./OpenLocker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports